var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Katalon Studio Enterprise") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KSE_logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-42",
    fill: "#9DCC3D",
    points: "7.38964445e-13 26 13 26 12.9953218 20.8068836 26 0 3.69482223e-13 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-11",
    fill: "#67B340",
    transform: "translate(15.710878, 17.333333) scale(-1, 1) translate(-15.710878, -17.333333) ",
    points: "5.4217569 26 21.8525199 26 26 19.2953298 16.2131402 8.66666667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87518275,6.5 L17.5067617,6.5 C17.8846407,6.5 18.1909722,6.80633149 18.1909722,7.18421053 L18.1909722,18.8157895 C18.1909722,19.1936685 17.8846407,19.5 17.5067617,19.5 L5.87518275,19.5 C5.49730371,19.5 5.19097222,19.1936685 5.19097222,18.8157895 L5.19097222,7.18421053 C5.19097222,6.80633149 5.49730371,6.5 5.87518275,6.5 Z",
    id: "Rectangle-Copy-14",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41536712,9.52430556 C11.0081599,9.52430556 11.7108626,10.4612425 11.7108626,10.4612425 C11.188966,11.315729 10.9280178,11.7429722 10.9280178,11.7429722 C10.8623304,11.6511773 10.7812968,11.5587328 10.6849167,11.4656389 C10.6849167,11.4656389 10.249241,11.0234047 9.6027545,11.0234047 C9.18113288,11.0234047 8.76138514,11.1886303 8.76138514,11.5855668 C8.76138514,12.4756569 11.9450968,12.0071884 11.9450968,14.3026839 C11.9450968,15.4738551 10.9613131,16.4576389 9.32167342,16.4576389 C8.06563753,16.4576389 7.25889067,15.867259 6.90625,15.5421204 C6.90625,15.5421204 7.16870159,15.1133593 7.69360476,14.2558371 C7.69360476,14.2558371 8.29104279,14.9585398 9.13428604,14.9585398 C9.73108433,14.9585398 10.1995833,14.7675655 10.1995833,14.3026839 C10.1995833,13.2667915 6.93248423,13.9144915 6.93248423,11.53872 C6.93248423,10.5080893 7.91626802,9.52430556 9.41536712,9.52430556 Z M16.5089167,9.87097222 L16.5089167,11.1969722 L13.8569167,11.1969722 L13.8569167,12.3293749 L15.8849167,12.3293749 L15.8849167,13.667632 L13.8569167,13.667632 L13.8569167,14.8239722 L16.5089167,14.8239722 L16.5089167,16.1109722 L12.4529167,16.1109722 L12.4529167,9.87097222 L16.5089167,9.87097222 Z",
    id: "Combined-Shape",
    fill: "#67B340",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKseLogo);
export default __webpack_public_path__ + "static/media/KSE_logo.9c2146885599bd6748fc89ba2d54b1c0.svg";
export { ForwardRef as ReactComponent };